export default __webpack_public_path__ + "static/media/hiw-a.cdaa7158.svg";